import { render, staticRenderFns } from "./lowPriceDetailPreview.vue?vue&type=template&id=fd524340&scoped=true"
import script from "./lowPriceDetailPreview.vue?vue&type=script&lang=js"
export * from "./lowPriceDetailPreview.vue?vue&type=script&lang=js"
import style0 from "./lowPriceDetailPreview.vue?vue&type=style&index=0&id=fd524340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd524340",
  null
  
)

export default component.exports